import styled from '@emotion/styled'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import LogoCarouselTemplate from '@segment/templates/LogoCarousel'
import { carouselLogos } from '@segment/templates/LogoCarousel/data'

const logos = [
  carouselLogos.ALLERGAN,
  carouselLogos.ANGI,
  carouselLogos.AB_IN_BEV,
  carouselLogos.AUTODESK,
  carouselLogos.AVANT,
  carouselLogos.CAMPING_WORLD,
  carouselLogos.CROSS_FIT,
  carouselLogos.CRUNCHY_ROLL,
  carouselLogos.CSAA,
  carouselLogos.FRAME_IO,
  carouselLogos.FRASERS_GROUP,
  carouselLogos.IBM,
  carouselLogos.IMAX,
  carouselLogos.MADEIRA_MADEIRA,
]

const LogoCarousel = () => (
  <StyledSection variant="centered">
    <StyledLogoCarousel logos={logos} />
  </StyledSection>
)

const StyledSection = styled(SectionBase)`
  ${Section.Wrapper} {
    gap: 0;
    padding-bottom: 0;
  }
`

const StyledLogoCarousel = styled(LogoCarouselTemplate)`
  padding: 0;
`

export default LogoCarousel
